import { FullValidationErrorFragmentType } from '@common/graphql/fragments';

export const validationBaseErrorsResponseParser = (
  response: { errors?: FullValidationErrorFragmentType[] } | null
) => {
  const messages = response?.errors
    ?.filter((e) => e?.attribute === 'base')
    .map((e) => e?.fullErrors);

  return messages && messages.length > 0 ? messages?.join(', ') : null;
};
